module.exports = __webpack_public_path__ + "img/门禁.d9048a34.jpg";